import { Button, DownloadIcon } from '@methanesat/ui-components';
import { useTranslate } from '../../../../../hooks';

export const OGIDownloadButton = ({ onClick, disabled }: { onClick: () => void, disabled: boolean }) => {
    const t = useTranslate();
    return (
        <Button
            data-testid="ogi-download-button"
            variant="outlined"
            color="info"
            onClick={onClick}
            endIcon={<DownloadIcon/>}
            disabled={disabled}
        >
            {t('emissionsMapPage.infrastructure.ogiNearEmissions.downloadButtonLabel')}
        </Button>
    );
};